



// import React, { useState } from 'react';
// import ProtectCloud from './ProtectCloud';
// import ProtectCloudFeatures from './ProtectCloudFeatures';
// import CyberProtectPackages from './CyberProtectPackages';

// // React Icons
// import { MdChatBubble } from "react-icons/md";
// import { IoCloseOutline } from "react-icons/io5";

// import '../Stylesp/index.css';

// const Index = () => {
//     const [isFormOpen, setIsFormOpen] = useState(false);

//     const toggleForm = () => setIsFormOpen(!isFormOpen);

//     return (
//         <div className="endpoint-page-wrapper">
//             {/* Main Page Sections */}
//             <ProtectCloud />
//             <ProtectCloudFeatures />
//             <CyberProtectPackages />

//             {/* Global Floating Action Button - Positioned Bottom Left */}
//             <div className="fab-container" onClick={toggleForm} title="Request a Demo">
//                 <MdChatBubble size={28} color="white" />
//                 <span className="fab-label">Quick Demo</span>
//             </div>

//             {/* Global Modal Overlay */}
//             {isFormOpen && (
//                 <div className="modal-overlay" onClick={toggleForm}>
//                     <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//                         <button className="close-modal" onClick={toggleForm}>
//                             <IoCloseOutline size={30} />
//                         </button>
//                         <div className="form-container modal-form">
//                             <h2 className="form-title">Request for a Quick Demo</h2>
//                             <form onSubmit={(e) => e.preventDefault()}>
//                                 <div className="form-group">
//                                     <label htmlFor="modal-name">Your Name *</label>
//                                     <input type="text" id="modal-name" required />
//                                 </div>
//                                 <div className="form-group">
//                                     <label htmlFor="modal-email">Email *</label>
//                                     <input type="email" id="modal-email" required />
//                                 </div>
//                                 <div className="button-wrapper">
//                                     <button type="submit" className="submit-button">
//                                         Submit Request
//                                     </button>
//                                 </div>
//                             </form>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Index;

















import React, { useState } from 'react';
import ProtectCloud from './ProtectCloud';
import ProtectCloudFeatures from './ProtectCloudFeatures';
import CyberProtectPackages from './CyberProtectPackages';

// React Icons
import { MdChatBubble } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";

import '../Stylesp/index.css';

const Index = () => {
    const [isFormOpen, setIsFormOpen] = useState(false);
    // State to manage form inputs
    const [formData, setFormData] = useState({ name: '', email: '' });
    const [loading, setLoading] = useState(false);

    const toggleForm = () => {
        setIsFormOpen(!isFormOpen);
        setFormData({ name: '', email: '' }); // Reset on close/open
    };

    const handleChange = (e) => {
        const { id, value } = e.target;
        // Map id (modal-name) to payload keys (name)
        const key = id.split('-')[1]; 
        setFormData(prev => ({ ...prev, [key]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const payload = {
            name: formData.name,
            email: formData.email,
            service: "Quick demo" // Hardcoded as requested
        };

        try {
            const response = await fetch('https://oet4v31oti.execute-api.us-east-2.amazonaws.com/dev/submit', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                alert('Request submitted successfully!');
                toggleForm();
            } else {
                alert('Something went wrong. Please try again.');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('Network error. Please check your connection.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="endpoint-page-wrapper">
            <ProtectCloud />
            <ProtectCloudFeatures />
            <CyberProtectPackages />

            <div className="fab-container" onClick={toggleForm} title="Request a Demo">
                <MdChatBubble size={28} color="white" />
                <span className="fab-label">Quick Demo</span>
            </div>

            {isFormOpen && (
                <div className="modal-overlay" onClick={toggleForm}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-modal" onClick={toggleForm}>
                            <IoCloseOutline size={30} />
                        </button>
                        <div className="form-container modal-form">
                            <h2 className="form-title">Request for a Quick Demo</h2>
                            <form onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="modal-name">Your Name *</label>
                                    <input 
                                        type="text" 
                                        id="modal-name" 
                                        required 
                                        value={formData.name}
                                        onChange={handleChange}
                                        disabled={loading}
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="modal-email">Email *</label>
                                    <input 
                                        type="email" 
                                        id="modal-email" 
                                        required 
                                        value={formData.email}
                                        onChange={handleChange}
                                        disabled={loading}
                                    />
                                </div>
                                <div className="button-wrapper">
                                    <button 
                                        type="submit" 
                                        className="submit-button"
                                        disabled={loading}
                                    >
                                        {loading ? 'Submitting...' : 'Submit Request'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Index;